const clamp = function(input, min, max) {
    return input < min ? min : input > max ? max : input;
};

export default clamp;
//# sourceMappingURL=clamp.js.map